import { cn } from "@/lib/utils";

export function BrandMark({ size = 48, className }: { size?: number; className?: string }) {
  return (
    <div
      className={cn("rounded-2xl flex items-center justify-center shadow-lg", className)}
      style={{
        width: size,
        height: size,
        background: "var(--cc-gradient-brand)",
      }}
    >
      <svg width={size * 0.6} height={size * 0.6} viewBox="0 0 52 52" fill="none" aria-hidden>
        <path
          d="M8 14a6 6 0 0 1 6-6h24a6 6 0 0 1 6 6v18a6 6 0 0 1-6 6H22l-8 6v-6h-0a6 6 0 0 1-6-6V14Z"
          fill="#FFFFFF"
        />
        <g stroke="hsl(var(--cc-terracotta))" strokeWidth="1.5" fill="none">
          <circle cx="26" cy="22" r="5" />
          <line x1="26" y1="13" x2="26" y2="16" />
          <line x1="26" y1="28" x2="26" y2="31" />
          <line x1="17" y1="22" x2="20" y2="22" />
          <line x1="32" y1="22" x2="35" y2="22" />
          <line x1="19.5" y1="15.5" x2="21.6" y2="17.6" />
          <line x1="30.4" y1="26.4" x2="32.5" y2="28.5" />
          <line x1="32.5" y1="15.5" x2="30.4" y2="17.6" />
          <line x1="21.6" y1="26.4" x2="19.5" y2="28.5" />
        </g>
      </svg>
    </div>
  );
}

export function BrandWordmark({ className }: { className?: string }) {
  return (
    <h1 className={cn("font-display font-extrabold tracking-tight", className)}>
      <span className="text-cc-ink">Chit</span>
      <span className="text-cc-terracotta">Chat</span>
    </h1>
  );
}
